import React, { Fragment, useEffect, useState } from 'react'
import { func, string, bool, object } from 'prop-types'
import { useSolicitacaoCancelamento } from '../../contexts/SolicitacaoCancelamentoContext'
import ModalConfirmacao from '../../components/ModalConfirmacao/ModalConfirmacao'
import Mensagem from '../Mensagem/Mensagem'
import { getAssinaturaDoAssociadoPorModalidade } from '../../utils/helpers/helpersAssinatura'
import { MODAL_CONFIRMACAO_TITULO, MODAL_CONFIRMACAO_DESCRICAO, BOTAO_MODAL_CANCELAR, BOTAO_MODAL_DESFAZER_SOLICITACAO } from '../../containers/Modalidade/Plano/CancelarAssinatura/constantsCancelarAssinatura'
import { DESFAZER_CANCELAMENTO_TITULO, DESFAZER_CANCELAMENTO_TEXTO } from '../InformacaoPlano/constantsInformacaoPlano'
import ModalCancelarSolicitacao from '../../containers/Modalidade/Plano/CancelarAssinatura/components/ModalCancelarSolicitacao/ModalCancelarSolicitacao'
import { useGlobal } from '../../contexts/GlobalContext'
import Button from '@taglivros/oef_componentes/build/components/button'

const DesfazerCancelamento = ( { getDados, tituloModalidade, onlyButton = false, tema } ) => {
  const {
    confirmacaoDesfazerCancelamento,
    desfazerCancelamento,
    solicitacaoCancelamentoDesfeita,
    setSolicitacaoCancelamentoDesfeita,
    ofereceDesfazerCancelamento,
    setConfirmacaoDesfazerCancelamento
  } = useSolicitacaoCancelamento()
  const [ modal, setModal ] = useState()
  const [ idAssinatura, setIdAssinatura ] = useState()
  const { dadosGlobaisAssociado } = useGlobal()
  const [ modalConfirmacaoDesfazerCancelamento, setModalConfirmacaoDesfazerCancelamento ] = useState()

  useEffect( () => {
    if ( dadosGlobaisAssociado ) {
      const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, tituloModalidade )

      if ( assinaturaObtida ) {
        setIdAssinatura( assinaturaObtida.id )
      }
    }
  }, [ dadosGlobaisAssociado ] )

  useEffect( () => {
    if ( confirmacaoDesfazerCancelamento ) {
      setModalConfirmacaoDesfazerCancelamento( true )
    }

    if ( solicitacaoCancelamentoDesfeita ) {
      setModal( true )
    }
  }, [ confirmacaoDesfazerCancelamento, solicitacaoCancelamentoDesfeita ] )

  return (
    <Fragment>
      { modalConfirmacaoDesfazerCancelamento ?
        <ModalConfirmacao
          acaoPrimariaTitulo={ BOTAO_MODAL_DESFAZER_SOLICITACAO }
          acaoSecundariaTitulo={ BOTAO_MODAL_CANCELAR }
          descricao={ MODAL_CONFIRMACAO_DESCRICAO }
          noMaxWidth
          onClickAcaoPrimaria={ () => {
            setModalConfirmacaoDesfazerCancelamento( false )
            setConfirmacaoDesfazerCancelamento( false )
            desfazerCancelamento( idAssinatura )
          } }
          onClickAcaoSecundaria={ () => {
            setModalConfirmacaoDesfazerCancelamento( false )
            setConfirmacaoDesfazerCancelamento( false )
          } }
          titulo={ MODAL_CONFIRMACAO_TITULO }
        /> : null}

      { modal ?
        <ModalCancelarSolicitacao
          onClickBotao={ () => {
            setModal( false )
            setSolicitacaoCancelamentoDesfeita( false )
            getDados()
            document.location.reload( true )
          } }
          onShowModal={ () => {
            setModal( false )
            document.location.reload( true )
          } }
          show={ modal }
        /> : null}

      {onlyButton ?
        <Button
          onClick={ () => ofereceDesfazerCancelamento() }
          tema={ tema }
        >
          {DESFAZER_CANCELAMENTO_TITULO}
        </Button> :
        <Mensagem
          acao={ DESFAZER_CANCELAMENTO_TITULO }
          handleClick={ () => ofereceDesfazerCancelamento() }
          texto={ DESFAZER_CANCELAMENTO_TEXTO }
        />}
    </Fragment>
  )
}

DesfazerCancelamento.propTypes = {
  'getDados': func.isRequired,
  'resumido': bool.isRequired,
  'tituloModalidade': string.isRequired,
  'onlyButton': bool.isRequired,
  'tema': object.isRequired,
}

export default DesfazerCancelamento
